/* FUNCTIONS : SUBMIT GENERAL FORM */

export let lock = false;

export const set_msg = data => {
  if (data.msg && data.msg != '') {
    console.log(data.msg);
  }
};

export const submit_form = (form, token) => {
  if (!lock) {
    lock = true;
    const url = form.dataset.action ? form.dataset.action : form.getAttribute('action');

    let formData = new FormData(form);
    if (token) {
      formData.append('token', token);
    }

    fetch(url ? url : window.location.href, {
      method: 'POST',
      enctype: 'multipart/form-data',
      body: formData,
    })
      .then(r => r.json())
      .then(data => {
        lock = false;

        const errorFields = form.querySelector('.is-invalid');
        if (errorFields) {
          errorFields.classList.remove('is-invalid');
        }

        if (data.success) {
          if (data.redirect) {
            document.location.href = data.redirect;
          } else if (data.msg) {
            form.parentElement.appendHtml('<p class="msg">' + data.msg + '</p>');
            form.remove();
          }
        } else {
          if (data.errors) {
            Object.keys(data.errors).forEach(name => {
              const item = form.querySelector(`*[name="${name}"]`);
              if (item) {
                item.classList.add('is-invalid');
                const closestGroup = item.closest('label');
                if (closestGroup) {
                  closestGroup.classList.add('is-invalid');
                }
              }
            });
          }

          const hasRecaptcha = document.querySelector('g-recaptcha');
          if (hasRecaptcha && data.captcha_success && data.captcha_success != 1) {
            grecaptcha.reset();
          }

          const errors = document.querySelectorAll('.is-invalid');

          /* if (errors.length > 0) {
						errors[0].scrollIntoView();
          } */

          set_msg(data);
        }
      })
      .catch(error => {
        lock = false;

        console.log('error handing here');
        /*** REMOVE IF LIVE SERVER IS NOT EMPTY ROOT ***/
        if (initVals.webRoot == '') {
          document.location.href = '/';
        } else {
          console.log(error);
        }
      });
  }
};
